import { render, staticRenderFns } from "./SaiTextArea.vue?vue&type=template&id=932c56b2&scoped=true"
import script from "./SaiTextArea.vue?vue&type=script&lang=js"
export * from "./SaiTextArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "932c56b2",
  null
  
)

export default component.exports